import { render, staticRenderFns } from "./edito-highlight.vue?vue&type=template&id=40e1c568"
import script from "./edito-highlight.vue?vue&type=script&lang=js"
export * from "./edito-highlight.vue?vue&type=script&lang=js"
import style0 from "./edito-highlight.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiIcon: require('/home/node/app/components/elements/ui-icon/ui-icon.vue').default,PatternsUiCta: require('/home/node/app/components/patterns/ui-cta/ui-cta.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
